const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const PUBLIC_MEDIA = (path) => `${API}/public-media/${path}`;

export const BRAND = {
  name: "Theo-Oppolia",
  fullName: "Theo-Oppolia Cabinet",
  website: "www.theooppolia.ca",
  websiteUrl: "https://www.theooppolia.ca",
  tagline: "The Whole-House Custom Cabinet Solutions",
  shortDesc: "OPPOLIA Canada — premium whole-home cabinetry and interior solutions",
  parentSite: "oppoliahome.com",
  parentSiteUrl: "https://oppoliahome.com",
  // Main / general line (NBSP + non-breaking hyphen so the number never wraps).
  phone: "+1\u00A0(905)\u00A0363\u20117673",
  phoneRaw: "+19053637673",
  // Direct sales line — drives quotes & consultations.
  phoneSales: "+1\u00A0(289)\u00A0965\u20118505",
  phoneSalesRaw: "+12899658505",
  email: "info@theooppolia.ca",
  emailRaw: "info@theooppolia.ca",
  emailSales: "sales@theooppolia.ca",
  address: "1254 South Service Road, B22/B23, Stoney Creek, Ontario L8E 5R9",
  addressShort: "Stoney Creek, Ontario",
  showroomOpeningSoon: true,
  facebookUrl: "https://facebook.com/TheoOppoliaCanada",
  instagramUrl: "https://www.instagram.com/theooppolia/",
  linkedinUrl: "https://www.linkedin.com/company/theo-oppolia/",
  twitterUrl: "https://x.com/THEOOPPOLIACA",
  tiktokUrl: "https://tiktok.com/@theooppolia",
  logoUrl: PUBLIC_MEDIA("theo-oppolia/public/logo_transparent_v2.png"),
  virtualShowroomUrl: "https://v.good720.com/oppolia2024/",
  // Multi-VR support. First entry stays backward-compat with `virtualShowroomUrl`.
  virtualShowrooms: [
    {
      id: "hq-2024",
      label: "OPPOLIA HQ Showroom",
      subtitle: "Flagship factory experience centre — 2026 edition",
      url: "https://v.good720.com/oppolia2024/",
    },
    {
      id: "full-house-2025",
      label: "Full-House VR Showroom 2025",
      subtitle: "OPPOLIA whole-house collections — newest 2025 release",
      url: "https://www.oppoliahome.com/full-house-vr-showroom/2025/",
    },
  ],
  catalogPdfUrl: PUBLIC_MEDIA("theo-oppolia/public/catalog_v3.pdf"),
  // Multi-catalog system. `catalogPdfUrl` is preserved for backward-compat
  // (any older link in emails / partner sites). `catalogues` is the canonical
  // list rendered by /catalog and any future "All catalogues" page.
  catalogues: [
    {
      id: "main",
      label: "Theo-Oppolia · Whole-House Cabinetry Catalogue",
      subtitle: "The complete page-by-page English edition — collections, finishes, and configurations for every room (compressed)",
      url: PUBLIC_MEDIA("theo-oppolia/public/catalogue_theo_oppolia_whole_house.pdf"),
      year: 2026,
    },
    {
      id: "global-cases-2026",
      label: "OPPOLIA Whole-House Global Cases 2026",
      subtitle: "Direct-retail case studies from OPPOLIA installations worldwide (compressed)",
      url: PUBLIC_MEDIA("theo-oppolia/public/catalogue_oppolia_global_cases_2026.pdf"),
      year: 2026,
    },
    {
      id: "master-furniture-lt2026",
      label: "OPPOLIA Master Furniture Catalogue · LT 2026",
      subtitle: "Loose furniture & lighting — beds, sofas, dining, occasional, lighting (compressed)",
      url: PUBLIC_MEDIA("theo-oppolia/public/catalogue_master_furniture_lt2026.pdf"),
      year: 2026,
    },
    {
      id: "whole-house-2026-update1",
      label: "OPPOLIA Whole-House Catalogue · 2026 (Update 1)",
      subtitle: "The complete high-resolution whole-home catalogue — kitchens, wardrobes, vanities, doors, TV walls (compressed from 176 MB to 19 MB)",
      url: PUBLIC_MEDIA("theo-oppolia/public/catalogue_whole_house_2026_update1.pdf"),
      year: 2026,
    },
    {
      id: "oppolia-2026b-whole-house",
      label: "OPPOLIA 2026B · Whole-House Design Catalogue",
      subtitle: "The 2026B edition featuring the Lumi Haven, Sylva, Seville, Monet, Minimalist, Monika and Renaut series — 85 pages of curated whole-home scenes (compressed & rebranded)",
      url: PUBLIC_MEDIA("theo-oppolia/public/catalogue_oppolia_2026b_whole_house.pdf"),
      year: 2026,
    },
  ],
  oneStopDiagramUrl: PUBLIC_MEDIA("theo-oppolia/public/onestop_diagram.png"),
  heroVideos: [
    PUBLIC_MEDIA("theo-oppolia/public/home_video_v2.mp4"),
  ],
  heroPosters: [
    PUBLIC_MEDIA("theo-oppolia/public/photos/opp_3.webp"),
    PUBLIC_MEDIA("theo-oppolia/public/photos/opp_5.webp"),
    PUBLIC_MEDIA("theo-oppolia/public/photos/opp_4.webp"),
    PUBLIC_MEDIA("theo-oppolia/public/photos/opp_2.webp"),
  ],
  serviceTags: ["Kitchen", "Bathroom", "Bedroom", "TV Panel", "Doors & Windows", "Furniture"],
};

export const CATEGORIES = [
  { slug: "Kitchen Cabinets", name: "Kitchen Cabinets", overline: "Exquisite", image: PUBLIC_MEDIA("theo-oppolia/public/photos/opp_4.webp"), span: "lg:col-span-7 lg:row-span-2" },
  { slug: "Bedroom Wardrobes", name: "Bedroom Wardrobes", overline: "Sanctuary", image: PUBLIC_MEDIA("theo-oppolia/public/photos/opp_3.webp"), span: "lg:col-span-5" },
  { slug: "Bathroom Vanities", name: "Bathroom Vanities", overline: "Refresh", image: "https://images.unsplash.com/photo-1765745518739-bd8225374713?crop=entropy&cs=srgb&fm=jpg&q=85", span: "lg:col-span-5" },
  { slug: "TV Panels", name: "TV Panels & Walls", overline: "Architectural", image: PUBLIC_MEDIA("theo-oppolia/public/tv_panel_new.webp"), span: "lg:col-span-5" },
  { slug: "Walk-in Closets", name: "Walk-in Closets", overline: "Curated", image: "https://images.unsplash.com/photo-1774301211236-dab64d553241?crop=entropy&cs=srgb&fm=jpg&q=85", span: "lg:col-span-7" },
  { slug: "Living Room", name: "Living Room", overline: "Salon", image: PUBLIC_MEDIA("theo-oppolia/public/photos/opp_5.webp"), span: "lg:col-span-4" },
  { slug: "Loose Furniture", name: "Loose Furniture", overline: "Director", image: PUBLIC_MEDIA("theo-oppolia/public/photos/opp_2.webp"), span: "lg:col-span-4" },
  { slug: "Doors & Windows", name: "Doors & Windows", overline: "Threshold", image: PUBLIC_MEDIA("theo-oppolia/public/catalog/page_12.jpg"), span: "lg:col-span-4" },
];

export const ADVANTAGES = [
  { icon: "Layers", titleKey: "adv.whole.title", bodyKey: "adv.whole.body" },
  { icon: "Award", titleKey: "adv.world.title", bodyKey: "adv.world.body" },
  { icon: "ShieldCheck", titleKey: "adv.safety.title", bodyKey: "adv.safety.body" },
  { icon: "PenTool", titleKey: "adv.design.title", bodyKey: "adv.design.body" },
  { icon: "Truck", titleKey: "adv.delivery.title", bodyKey: "adv.delivery.body" },
  { icon: "Sparkles", titleKey: "adv.trade.title", bodyKey: "adv.trade.body" },
];

// Stats re-aligned Feb 2026 to match the OPPOLIA parent-brand layout the
// client approved: 1.4M AI Factory · 100+ Export Countries · 2,700+ Global
// Showrooms · 10,000+ Projects Completed. Values are the official OPPOLIA /
// OPPEIN group figures as rendered on oppoliahome.com.
export const STATS = [
  { value: 1.4, suffix: "M m²", labelKey: "stats.factory", format: "decimal" },
  { value: 100, suffix: "+", labelKey: "stats.countries" },
  { value: 2700, suffix: "+", labelKey: "stats.showrooms" },
  { value: 10000, suffix: "+", labelKey: "stats.projects" },
];

export const NAV_LINKS = [
  { name: "Home", path: "/", fr: "Accueil" },
  { name: "Products", path: "/products", fr: "Produits" },
  { name: "Catalog", path: "/catalog", fr: "Catalogue" },
  { name: "Showroom", path: "/showroom", fr: "Salle d'exposition" },
  { name: "Projects", path: "/projects", fr: "Projets" },
  { name: "Blog", path: "/blog", fr: "Blog" },
  { name: "Careers", path: "/careers", fr: "Carrières" },
  { name: "About", path: "/about", fr: "À propos" },
  { name: "Contact", path: "/contact", fr: "Contact" },
];
